const resource = 'conversations'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  getPublic(id, signature) {
    const url = `/${resource}/${id}/public`
    return $axios.$get(signature ? `${url}?signature=${signature}` : url)
  },
  create(params) {
    return $axios.$post(`/${resource}`, params)
  },
  update(id, params) {
    return $axios.$put(`/${resource}/${id}`, params)
  },
  addMessage(id, params) {
    return $axios.$post(`/${resource}/${id}/conversation_messages`, params, {
      headers: { 'content-type': 'multipart/form-data' },
    })
  },
  addMessagePublic(id, signature, params) {
    const url = `/${resource}/${id}/public/conversation_messages`
    return $axios.$post(signature ? `${url}?signature=${signature}` : url, params, {
      headers: { 'content-type': 'multipart/form-data' },
    })
  },
  fetchMessages(id, params) {
    return $axios.$get(`/${resource}/${id}/conversation_messages`, { params })
  },
  markMessageAsRead(messageId) {
    return $axios.$put(`/conversation_messages/${messageId}`, { is_read: true })
  },

  fetchAccountConversations() {
    return $axios.$get('/v2/account/conversations')
  },

  fetchAccountConversation(id) {
    return $axios.$get(`/v2/account/conversations/${id}`)
  },

  getServiceName: name => 'conversationService',
})
